<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Performance Mentor">
            <br>
            <common-training-header :withUser="true"/>
        </a-page-header>

        <a-card type="inner" size="small" style="margin-top: 24px">
            <a-skeleton :loading="loading" active>
                <a-table
                    class="pcp-table"
                    :columns="columns"
                    :dataSource="tableData"
                    rowKey="id"
                    :pagination="false"
                    bordered>

                    <div slot="photo" slot-scope="record" style="text-align: center">
                        <a-avatar :src="record.photo" shape="square" :size="64" icon="user" />
                    </div>

                    <div slot="name" slot-scope="record" style="text-align: left">
                        {{ record.name }}
                    </div>

                    <div slot="notulen" slot-scope="record" style="text-align: center">
                        <a-tooltip title="Notulen">
                            <a-button
                                style="margin-left: 4px;"
                                size="small"
                                icon="file-text"
                                @click="notulen(record.hash)"
                            />
                        </a-tooltip>
                    </div>

                    <div slot="presentation" slot-scope="record" style="text-align: center">
                        <center>{{ record.scorer.presentation }}</center>
                    </div>

                    <div slot="content" slot-scope="record" style="text-align: center">
                        <center>{{ record.scorer.content }}</center>
                    </div>

                    <div slot="writing" slot-scope="record" style="text-align: center">
                        <center>{{ record.scorer.writing }}</center>
                    </div>

                    <div slot="final_result" slot-scope="record" style="text-align: center">
                        <center>{{ record.scorer.final_result }}</center>
                    </div>

                    <div slot="presentation_file" slot-scope="record" style="text-align: center">
                        <a-button type="link" size="small" @click="download(record.presentation_file)" v-show="record.presentation_file">
                            <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" />
                        </a-button>
                    </div>

                    <div slot="presentation_outline_file" slot-scope="record" style="text-align: center">
                        <a-button type="link" size="small" @click="download(record.presentation_outline_file)" v-show="record.presentation_outline_file">
                            <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" />
                        </a-button>
                    </div>

                    <template slot="footer" slot-scope="record" className="column-right">
                        <a-row type="flex" justify="end">
                            <a-col :span="4">

                            </a-col>
                            <a-col :span="2">

                            </a-col>
                        </a-row>
                    </template>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
const columns = [
    {
		key: 'photo',
		title: 'Foto',
        align: 'center',
		scopedSlots: {customRender: 'photo'},
	}, {
		key: 'name',
		title: 'Nama Lengkap',
        align: 'center',
		scopedSlots: {customRender: 'name'}
	}, {
		key: 'notulen',
		title: 'Notulen',
        align: 'center',
		scopedSlots: {customRender: 'notulen'}
	}, {
		key: 'total',
		title: 'Total Nilai',
		scopedSlots: {customRender: 'total'},
        children: [
            {
                key: 'presentation',
                title: 'Presentasi 20%',
                align: 'center',
                scopedSlots: {customRender: 'presentation'},
            },
            {
                key: 'content',
                title: 'Isi 60%',
                align: 'center',
                scopedSlots: {customRender: 'content'},
            },
            {
                key: 'writing',
                title: 'Penulisan 20%',
                align: 'center',
                scopedSlots: {customRender: 'writing'},
            },
        ]
	}, {
		key: 'final_result',
		title: 'Nilai Akhir',
		align: 'center',
		scopedSlots: {customRender: 'final_result'}
	}, {
		key: 'file',
		title: 'File',
		align: 'center',
        children: [
            {
                key: 'presentation_file',
                title: 'Presentasi',
                align: 'center',
                scopedSlots: {customRender: 'presentation_file'}
            }, {
                key: 'presentation_outline_file',
                title: 'Makalah',
                align: 'center',
                scopedSlots: {customRender: 'presentation_outline_file'}
            }
        ]

	}
]

export default {
    data() {
        return {
            columns,
            loading: false,
            items: {},
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            let params = {
                user_hash: this.$laravel.user.hash,
                recap_type: 'evaluator'
            }

            this.loading = true

            this.$http
                .get(this.routeUri('api.recap.activity-score.attendants_result') + '?' + this.$qs.stringify(params))
                .then(response => this.items = response.data.attendants)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        notulen(user_hash){
            let params = {
                user_hash: user_hash,
                identity: 'report',
                previous: this.getRoute()
            }

            window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.notulen.form') + '?' + this.$qs.stringify(params)
        },
        download(url) {
            window.open(window.location.origin + url, '_blank')
        },
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        tableData(){
            if(this.items.length > 0){
                let idx = 0
                let collection = []
                let idx2 = 0
                let totPresentasi = 0
                let totIsi = 0
                let totPenulisan = 0

                this.items.forEach(function(item){
                    idx++
                    let scorer = {
                        presentation: 0,
                        content: 0,
                        writing: 0,
                        final_result: 0
                    }
                    item.evaluators.forEach(function(evaluator){
                        let scoreEvaluator = item.activities[0].evaluator_score[evaluator]

                        if(Array.isArray(scoreEvaluator) && scoreEvaluator.length > 0){
                            idx2++
                            scoreEvaluator.forEach(function(score){
                                if(score.scoreable.scoreable_type === 'aspect' && score.scoreable.code === 'PPR-PRM'){
                                    totPresentasi = parseFloat(totPresentasi) + parseFloat(score.score)
                                }else if(score.scoreable.scoreable_type === 'aspect' && score.scoreable.code === 'PPR-CTN'){
                                    totIsi = parseFloat(totIsi) + parseFloat(score.score)
                                }else if(score.scoreable.scoreable_type === 'aspect' && score.scoreable.code === 'PPR-TEK'){
                                    totPenulisan = parseFloat(totPenulisan) + parseFloat(score.score)
                                }
                            })

                            let presentasi = totPresentasi / idx2
                            let isi = totIsi / idx2
                            let penulisan = totPenulisan / idx2

                            scorer['presentation'] = parseFloat(presentasi).toFixed(2)
                            scorer['content'] = parseFloat(isi).toFixed(2)
                            scorer['writing'] = parseFloat(penulisan).toFixed(2)

                            scorer['final_result'] = parseFloat(presentasi + isi + penulisan).toFixed(2)
                        }
                    })

                    collection.push({
                        id: idx,
                        name: item.name,
                        presentation_file: item.activities[0].presentation_file,
                        presentation_outline_file: item.activities[0].presentation_outline_file,
                        hash: item.hash,
                        scorer
                    })
                })
                return collection
            }
            return []
        }
    },
}
</script>
